module.exports = __webpack_public_path__ + "static/media/High-Volume Hiring.bca4a996.png";